/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomerOrderDetails } from './CustomerOrderDetails';
import {
    CustomerOrderDetailsFromJSON,
    CustomerOrderDetailsFromJSONTyped,
    CustomerOrderDetailsToJSON,
    CustomerOrderDetailsToJSONTyped,
} from './CustomerOrderDetails';
import type { CustomerOrderItemsByCustomerOrderSummary } from './CustomerOrderItemsByCustomerOrderSummary';
import {
    CustomerOrderItemsByCustomerOrderSummaryFromJSON,
    CustomerOrderItemsByCustomerOrderSummaryFromJSONTyped,
    CustomerOrderItemsByCustomerOrderSummaryToJSON,
    CustomerOrderItemsByCustomerOrderSummaryToJSONTyped,
} from './CustomerOrderItemsByCustomerOrderSummary';

/**
 * 
 * @export
 * @interface CustomerOrderDetailsWithOrderItems
 */
export interface CustomerOrderDetailsWithOrderItems {
    /**
     * 
     * @type {CustomerOrderDetails}
     * @memberof CustomerOrderDetailsWithOrderItems
     */
    customerOrderDetails: CustomerOrderDetails;
    /**
     * 
     * @type {Array<CustomerOrderItemsByCustomerOrderSummary>}
     * @memberof CustomerOrderDetailsWithOrderItems
     */
    customerOrderItems: Array<CustomerOrderItemsByCustomerOrderSummary>;
}

/**
 * Check if a given object implements the CustomerOrderDetailsWithOrderItems interface.
 */
export function instanceOfCustomerOrderDetailsWithOrderItems(value: object): value is CustomerOrderDetailsWithOrderItems {
    if (!('customerOrderDetails' in value) || value['customerOrderDetails'] === undefined) return false;
    if (!('customerOrderItems' in value) || value['customerOrderItems'] === undefined) return false;
    return true;
}

export function CustomerOrderDetailsWithOrderItemsFromJSON(json: any): CustomerOrderDetailsWithOrderItems {
    return CustomerOrderDetailsWithOrderItemsFromJSONTyped(json, false);
}

export function CustomerOrderDetailsWithOrderItemsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerOrderDetailsWithOrderItems {
    if (json == null) {
        return json;
    }
    return {
        
        'customerOrderDetails': CustomerOrderDetailsFromJSON(json['customerOrderDetails']),
        'customerOrderItems': ((json['customerOrderItems'] as Array<any>).map(CustomerOrderItemsByCustomerOrderSummaryFromJSON)),
    };
}

export function CustomerOrderDetailsWithOrderItemsToJSON(json: any): CustomerOrderDetailsWithOrderItems {
    return CustomerOrderDetailsWithOrderItemsToJSONTyped(json, false);
}

export function CustomerOrderDetailsWithOrderItemsToJSONTyped(value?: CustomerOrderDetailsWithOrderItems | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'customerOrderDetails': CustomerOrderDetailsToJSON(value['customerOrderDetails']),
        'customerOrderItems': ((value['customerOrderItems'] as Array<any>).map(CustomerOrderItemsByCustomerOrderSummaryToJSON)),
    };
}

